<template>
  <div class="ei-profile-growth-comparison">
    <a-card
        :bordered="true"
        class="ei-profile-growth-comparison__card pdf-avoid-break"
    >
      <a-tag class="ei-profile-growth-comparison__tag">
        {{ previousLabel }}
      </a-tag>

      <div class="ei-profile-growth-comparison__header">
        <h3 class="ei-profile-growth-comparison__title">
          {{ title }}
        </h3>

        <a-popover
            v-if="helpText"
            trigger="hover"
            placement="top"
        >
          <template #content>
            <div class="ei-profile-growth-comparison__popover">
              {{ helpText }}
            </div>
          </template>

          <QuestionCircleOutlined class="ei-profile-growth-comparison__help-icon" />
        </a-popover>
      </div>

      <EiScaleRowsTable
          class="ei-profile-growth-comparison__table"
          :sections="previousSections"
          :show-scale-after-each-section="true"
          :show-first-section-title="false"
          :show-difference="false"
          :row-gap="12"
          :scale-height="8"
      />
    </a-card>

    <a-card
        :bordered="true"
        class="ei-profile-growth-comparison__card pdf-avoid-break"
    >
      <a-tag class="ei-profile-growth-comparison__tag ei-profile-growth-comparison__tag--current">
        {{ currentLabel }}
      </a-tag>

      <div class="ei-profile-growth-comparison__header">
        <h3 class="ei-profile-growth-comparison__title">
          {{ title }}
        </h3>

        <a-popover
            v-if="helpText"
            trigger="hover"
            placement="top"
        >
          <template #content>
            <div class="ei-profile-growth-comparison__popover">
              {{ helpText }}
            </div>
          </template>

          <QuestionCircleOutlined class="ei-profile-growth-comparison__help-icon" />
        </a-popover>
      </div>

      <EiScaleRowsTable
          class="ei-profile-growth-comparison__table"
          :sections="currentSections"
          :show-scale-after-each-section="true"
          :show-first-section-title="false"
          :show-difference="false"
          :row-gap="12"
          :scale-height="8"
      />
    </a-card>
  </div>
</template>

<script>
import { QuestionCircleOutlined } from '@ant-design/icons-vue'

import EiScaleRowsTable from '@/components/Analytics/EiScaleRowsTable.vue'

export default {
  name: 'EiProfileGrowthComparisonBlock',

  components: {
    QuestionCircleOutlined,
    EiScaleRowsTable,
  },

  props: {
    previousLabel: {
      type: String,
      default: 'Было',
    },

    currentLabel: {
      type: String,
      default: 'Стало',
    },

    title: {
      type: String,
      default: 'Средний ЭИ-профиль',
    },

    helpText: {
      type: String,
      default: 'ЭИ-профиль с выделением сильных сторон и зон роста по общему ЭИ, доменам и ветвям.',
    },

    previousSections: {
      type: Array,
      default: () => [],
    },

    currentSections: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped lang="scss">
.ei-profile-growth-comparison {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.ei-profile-growth-comparison__card {
  position: relative;
  min-width: 0;
  border-radius: 8px;
}

.ei-profile-growth-comparison__card :deep(.ant-card-body) {
  padding: 18px 16px 14px;
}

.ei-profile-growth-comparison__tag {
  position: absolute;
  top: -10px;
  left: 20px;
  z-index: 2;
  margin: 0;
  height: 20px;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  font-size: 12px;
  line-height: 18px;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.65);
  border-color: #d5dbe2;
}

.ei-profile-growth-comparison__tag--current {
  color: var(--geek-blue);
  border-color: var(--geek-blue-3);
  background-color: var(--geek-blue-1);
}

.ei-profile-growth-comparison__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.ei-profile-growth-comparison__title {
  margin: 0;
  min-width: 0;
  font-weight: 600;
  font-size: 16px;
  line-height: 120%;
  color: rgba(0, 0, 0, 0.88);
}

.ei-profile-growth-comparison__help-icon {
  flex: 0 0 auto;
  color: rgba(0, 0, 0, 0.25);
  font-size: 14px;
  cursor: pointer;
}

.ei-profile-growth-comparison__popover {
  max-width: 260px;
  font-size: 13px;
  line-height: 130%;
}

.ei-profile-growth-comparison__table {
  width: 100%;
}

.ei-profile-growth-comparison :deep(.ei-scale-table__section-title) {
  margin: 2px 0 12px;
  font-size: 16px;
  line-height: 120%;
  color: rgba(0, 0, 0, 0.45);
}

.ei-profile-growth-comparison :deep(.ei-scale-table__rows-guides) {
  top: 22px;
  bottom: 18px;
}

.ei-profile-growth-comparison :deep(.ei-scale-table__row-header) {
  margin-bottom: 6px;
}

.ei-profile-growth-comparison :deep(.ei-scale-table__label) {
  font-size: 14px;
}

.ei-profile-growth-comparison :deep(.ei-scale-table__value) {
  min-width: 34px;
  font-weight: 600;
}

.ei-profile-growth-comparison :deep(.ei-scale-table__track) {
  background-color: #eef1f5;
}

.ei-profile-growth-comparison :deep(.ei-scale-table__bottom-scale),
.ei-profile-growth-comparison :deep(.ei-scale-table__scale) {
  margin-top: 6px;
}

.ei-profile-growth-comparison :deep(.ei-scale-table__scale-item) {
  color: rgba(0, 0, 0, 0.25);
}

@media (max-width: $tablet-breakpoint) {
  .ei-profile-growth-comparison {
    grid-template-columns: 1fr;
  }
}

@media (max-width: $mobile-breakpoint) {
  .ei-profile-growth-comparison__card :deep(.ant-card-body) {
    padding: 18px 12px 14px;
  }
}
</style>